export const LOGIN = 'login'
export const USER = 'user'

